import { useQueries } from '@tanstack/react-query';
import useBackendUser from './useBackendUser';
import getCtaCount from '@/api/getCtaCount';
import getNotiCount from '@/api/getNotiCount';
import getNotifications_v2 from '@/api/getNotifications_v2';

export default function useHeaderQuery() {
  const data = useBackendUser();

  const [ctaCountQuery, notificationCountQuery, notificationsQuery] = useQueries({
    queries: [
      {
        queryKey: ['ctaCount'],
        queryFn: getCtaCount,
        enabled: Boolean(data.data),
      },
      {
        queryKey: ['notificationCount'],
        queryFn: getNotiCount,
        enabled: Boolean(data.data),
      },
      {
        queryKey: ['notifications_header'],
        queryFn: () => getNotifications_v2(),
        enabled: Boolean(data.data),
      },
    ],
  });

  return {
    userQuery: data,
    ctaCountQuery,
    notificationCountQuery,
    notificationsQuery,
  };
}
